<template>
    <div class="Setting">
        <div class="LineCut flexbetween">
            <div class="NewsTitle flexa"><p>SETTING<span></span></p></div>
            <div class="Return flexa" @click="Return"><p>返回</p><img src="../../assets/Home/return.png"></div>
        </div>
        <div class="SafeWrap">
            <div class="Title"><p>安全</p></div>
            <div class="ChangePassword flexbetween" @click="ShowChangePasswd"><p>修改密码</p><img  src="../../assets/Buttonicon/go.png"></div>
      <!--      <div class="ChangePhone flexbetween"><p>手机号码修改</p><img  src="../../assets/Buttonicon/go.png"></div>-->
        </div>
     <!--   <div class="SafeWrap">
            <div class="Title"><p>通知</p></div>
            <div class="ChangePassword flexbetween"><p>新消息提醒</p><img  src="../../assets/Buttonicon/go.png"></div>
            <div class="ChangePhone flexbetween"><p>网站音效</p><img  src="../../assets/Buttonicon/go.png"></div>
        </div>
        <div class="SafeWrap">
            <div class="Title"><p>隐私</p></div>
            <div class="ChangePassword flexbetween"><p>隐私协议</p><img  src="../../assets/Buttonicon/go.png"></div>
        </div>-->
    </div>
</template>
<script>
  export default {
    data() {
      return {};
    },
    methods: {
      Return() {
        this.$router.back();
      },
      ShowChangePasswd() {
        this.$emit('ShowChangePasswd');
      }
    }
  };
</script>
<style lang="scss" scoped>
    @import '../../../public/Value';
    .Setting{
        width: 100%;
        .LineCut{
            width: 90%;
            margin: 0.05rem auto 0.05rem;
            border-bottom: 2px solid #fff;
            .Return{
                cursor: pointer;
                p{
                    font-size: $AdditionTextSize;
                    color: #fff;
                }
                img{
                    width: 0.05rem;
                    margin-left: 0.02rem;
                }
            }
            .NewsTitle{
                p{
                    font-size: $TitleSize;
                    color: #fff;
                    padding-bottom: 0.045rem;
                    span{
                        opacity: 0.6;
                        font-weight: normal;
                    }
                }
            }
        }
        .SafeWrap{
            width: 89%;
            margin: 0.15rem auto;
            .Title{
                p{
                    font-size: $TextSize;
                    color: #fff;
                    font-weight: bold;
                }
            }
            .ChangePassword,.ChangePhone{
                width: 98%;
                border-bottom: 1px solid #fff;
                padding: 0.05rem 0;
                margin: 0.08rem auto 0;
                cursor: pointer;
                img{
                    width: 0.04rem;
                    margin-right: 0.01rem;
                }
                p{
                    font-size: $AdditionTextSize;
                    color: #fff;
                    opacity: 0.8;
                    margin-left: 0.01rem;
                };
            }
            .ChangePhone{
                margin: 0.03rem auto 0;
            }
        }
    }
</style>
